import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { FeatureFlagUseCase, ProductAlias, ProductStatus } from '@ibk/shared-types';
import { Icon } from '@ibk/shared-ui';
import { generateMenuItems } from '@ibk/shared-utils';
export const supportAccountantMenuItem = { label: 'Suporte', icon: _jsx(Icon, { name: 'question' }), path: '/suporte' };
export function buildAccountantMenu({ products, isFeatureFlagWhiteListed, hasBillingPermission, hasAccountPjPermission, hasDigitalAccountingPermission, hasBenefitPermission, hasClientPortalViewPermission, isNFSeModuleEnabled, hasBillingManagementActive, isPointsProgramEnabled, hasFidelityProgramViewPermission, t, onLoyaltyProgramMenuClick, }) {
    const clientContabilidadeDigitalProduct = products[ProductAlias.CONTABILIDADE_DIGITAL];
    const isClientContabilidadeDigitalActive = !clientContabilidadeDigitalProduct.isLoading;
    const hasMyClientsAccess = !!hasBillingPermission && hasBillingManagementActive;
    const hasErpSettingsAccess = !!isFeatureFlagWhiteListed(FeatureFlagUseCase.ERP_SETTINGS);
    const menuConfig = {
        domain: 'escritorio',
        hasBillingAccess: !!hasBillingPermission,
        hasMyClientsAccess,
        hasNFSeModuleEnabled: isNFSeModuleEnabled,
        hasBillingManagementActive,
        supportMenuItem: supportAccountantMenuItem,
        IconComponent: Icon,
        ProductStatus: ProductStatus,
        hasAccountPjAccess: !!hasAccountPjPermission,
        hasDigitalAccountingAccess: !!hasDigitalAccountingPermission && isClientContabilidadeDigitalActive,
        hasClientPortalViewPermission: !!hasClientPortalViewPermission,
        hasBenefitAccess: !!hasBenefitPermission,
        hasCreditoPjAccess: false,
        hasErpSettingsAccess,
        hasLoyaltyProgramAccess: isPointsProgramEnabled && hasFidelityProgramViewPermission === true,
        hasClientCenterAccess: false,
        translate: t,
        ...(onLoyaltyProgramMenuClick ? { onLoyaltyProgramMenuClick } : {}),
    };
    const baseMenuItems = generateMenuItems({ ...menuConfig, hasTwoOrMoreAccesses: false });
    const functionalMenuItemsCount = baseMenuItems.filter(item => item.path !== supportAccountantMenuItem.path).length;
    const hasTwoOrMoreAccesses = functionalMenuItemsCount >= 2;
    return hasTwoOrMoreAccesses ? generateMenuItems({ ...menuConfig, hasTwoOrMoreAccesses: true }) : baseMenuItems;
}
